import { Component } from "react"
import { disableScroll, enableScroll } from "../common/disableScroll"

class Modal extends Component {
  constructor(props) {
    super(props)
    this.state = {}
  }

  componentDidMount() {
    disableScroll()
  }

  componentWillUnmount() {
    enableScroll()
  }

  render() {
    if (!this.props.visible) {
      enableScroll()
      return null
    }
    disableScroll()

    return (
      <div
        style={{
          position: "fixed",
          top: "0px",
          left: "0px",
          right: "0px",
          bottom: "0px",
          width: "100%",
          height: "100%",
          backgroundColor: "rgba(7, 7, 10, 0.8)",
       
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          zIndex: "1000",
        }}
      >
        <div
          style={{
            backgroundColor: "#02111B",
            width: "30%",
            maxWidth: "1000px",
            borderRadius: "10px",
            overflow: "hidden",
            border: "1px solid #FFC857",
          }}
        >
          {/* Header with title and close icon */}
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              padding: "12px 16px",
              backgroundColor: "#02111B",
              color: "white",
            }}
          >
            {this.props.title && (
              <div
                style={{
                  fontSize: "18px",
                  fontWeight: "600",
                }}
              >
                {this.props.title}
              </div>
            )}
            <button
              style={{
                background: "none",
                border: "none",
                fontSize: "24px",
                cursor: "pointer",
                color: "white",
                transition: "color 0.3s ease",
              }}
              onClick={() => {
                this.props.onClose()
                enableScroll()
              }}
            >
              ×
            </button>
          </div>

          {/* Content */}
          <div
            style={{
              maxHeight: "70vh",
              overflowY: "auto",
              padding: "16px",
              color: "white",
            }}
          >
            {this.props.children}
          </div>
        </div>
      </div>
    )
  }
}

export default Modal